import { Route, Routes } from 'react-router-dom';
import Home from './Pages/Home/Home';
import './App.css';
import Services from './Pages/Home/services';
import AboutUs from './Pages/Home/About';
import BandDisplay from './Pages/Home/brand';
import ProductSection from './Pages/Home/productshower';

function App() {
  return (
  <>
  <Routes>
    <Route path="/" element={<Home />} />
    <Route path="/home" element={<Home />} />
    <Route path="/service" element={<Services />} />
    <Route path="/about" element={<AboutUs />} />
    <Route path="/brand" element={<BandDisplay />} />
    <Route path="/product" element={<ProductSection />} />
  </Routes>
  </>
  );
}

export default App;
